// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1hLvA","consentsList":"PatientConsents_consentsList__1kyUq","consentsListEmpty":"PatientConsents_consentsListEmpty__XTQhB"};